import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AppShell } from "./layout/AppShell";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { RbacProvider } from "./auth/RbacContext";
import { getRbacConfig } from "./auth/bootstrapConfig";
import { Spinner } from "./components/rpe";

// Workspace — pure-custom wireframe pages (no Cloudscape)
const Home = lazy(() => import("./pages/Home/Home").then((m) => ({ default: m.Home })));
const PerformanceIntake = lazy(() =>
  import("./pages/PerfResiliency/PerformanceIntake").then((m) => ({ default: m.PerformanceIntake })),
);
const Validations = lazy(() =>
  import("./pages/PerfResiliency/Validations").then((m) => ({ default: m.Validations })),
);
const RunEvidence = lazy(() =>
  import("./pages/PerfResiliency/RunEvidence").then((m) => ({ default: m.RunEvidence })),
);
const WorkflowHealth = lazy(() =>
  import("./pages/PerfResiliency/WorkflowHealth").then((m) => ({ default: m.WorkflowHealth })),
);
const Analytics = lazy(() => import("./pages/Analytics/Analytics").then((m) => ({ default: m.Analytics })));
const Reports = lazy(() => import("./pages/Reports/Reports").then((m) => ({ default: m.Reports })));
const ReportDetail = lazy(() =>
  import("./pages/Reports/ReportDetail").then((m) => ({ default: m.ReportDetail })),
);
// Application Catalog
const Catalog = lazy(() => import("./pages/Catalog/Catalog").then((m) => ({ default: m.Catalog })));
const SingleOnboarding = lazy(() =>
  import("./pages/Catalog/SingleOnboarding").then((m) => ({ default: m.SingleOnboarding })),
);
const BulkOnboarding = lazy(() =>
  import("./pages/Catalog/BulkOnboarding").then((m) => ({ default: m.BulkOnboarding })),
);
const AppProfile = lazy(() => import("./pages/Catalog/AppProfile").then((m) => ({ default: m.AppProfile })));
// Settings
const UserTokenSettings = lazy(() => import("./pages/Settings/UserTokenSettings"));

export default function App() {
  return (
    <RbacProvider rbacConfig={getRbacConfig()}>
      <AppShell>
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />

              {/* Validate */}
              <Route path="/performance" element={<Navigate to="/performance/runs" replace />} />
              <Route path="/performance/intake" element={<PerformanceIntake />} />
              <Route path="/performance/runs" element={<Validations />} />
              <Route path="/performance/runs/:runId" element={<RunEvidence />} />
              <Route path="/performance/agents" element={<WorkflowHealth />} />

              {/* Sign off */}
              <Route path="/performance/analytics" element={<Analytics />} />
              <Route path="/performance/reports" element={<Reports />} />
              <Route path="/performance/reports/:runId" element={<ReportDetail />} />

              {/* Onboard — Application Catalog */}
              <Route path="/catalog" element={<Navigate to="/catalog/applications" replace />} />
              <Route path="/catalog/applications" element={<Catalog />} />
              <Route path="/catalog/applications/new" element={<SingleOnboarding />} />
              <Route path="/catalog/applications/bulk" element={<BulkOnboarding />} />
              <Route path="/catalog/applications/:applicationId" element={<AppProfile />} />
              <Route path="/catalog/applications/:applicationId/edit" element={<SingleOnboarding />} />

              {/* Settings */}
              <Route path="/settings/user-tokens" element={<UserTokenSettings />} />
            </Route>
          </Routes>
        </Suspense>
      </AppShell>
    </RbacProvider>
  );
}
